import React, { useState, useEffect } from "react";
import { TextField, Typography, Box, Button, Checkbox } from "@mui/material";

import {
  API_regen_tax_data,
  API_edit_tax_data,
  API_get_bookings_id,
} from "../utils/http";

export default function InputLeftTax({ booking_id }) {
  const [tax_data, set_tax_data] = useState(null);

  const handleSave = () => {
    API_edit_tax_data(booking_id, tax_data, (x) => {
      console.log(x);
    });
  };

  const handleRegen = () => {
    API_regen_tax_data(booking_id, (x) => {
      if (x.success) {
        set_tax_data(x.data?.tax_data);
      }
    });
  };

  useEffect(() => {
    API_get_bookings_id(booking_id, (x) => {
      if (x.success) {
        if (x.data?.tax_data) {
          set_tax_data(x.data?.tax_data);
        } else {
          handleRegen();
        }
      }
    });
  }, [booking_id]);

  return (
    <div>
      <Typography variant="h4">TAX</Typography>

      <Button
        style={{ position: "absolute", right: 10, top: 10, zIndex: 1000 }}
        variant="contained"
        onClick={handleSave}
      >
        Save
      </Button>
      <Button
        variant="outlined"
        onClick={() => {
          handleRegen();
        }}
      >
        Regen TAX data
      </Button>

      {tax_data != null ? (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <h3>Information</h3>
          <TextField
            style={{ margin: 5, flex: 1 }}
            id="Contract Number"
            label="Contract Number"
            variant="standard"
            value={tax_data.contract_number}
            onChange={(e) => {
              set_tax_data({
                ...tax_data,
                contract_number: e.target.value,
              });
            }}
          />
          {/* date contract */}
          <div style={{ display: "flex", flexDirection: "row" }}>
            <TextField
              style={{ margin: 5, flex: 1 }}
              id="Contract Date"
              label="Day"
              variant="standard"
              value={tax_data.contract_date_day}
              onChange={(e) => {
                set_tax_data({
                  ...tax_data,
                  contract_date_day: e.target.value,
                });
              }}
            />
            <TextField
              style={{ margin: 5, flex: 1 }}
              id="Contract Date"
              label="Month"
              variant="standard"
              value={tax_data.contract_date_month}
              onChange={(e) => {
                set_tax_data({
                  ...tax_data,
                  contract_date_month: e.target.value,
                });
              }}
            />
            <TextField
              style={{ margin: 5, flex: 1 }}
              id="Contract Date"
              label="Year"
              variant="standard"
              value={tax_data.contract_date_year}
              onChange={(e) => {
                set_tax_data({
                  ...tax_data,
                  contract_date_year: e.target.value,
                });
              }}
            />
          </div>
          <TextField
            style={{ margin: 5, flex: 1 }}
            id="Contract Date"
            label="customer name"
            variant="standard"
            value={tax_data.customer_name}
            onChange={(e) => {
              set_tax_data({
                ...tax_data,
                customer_name: e.target.value,
              });
            }}
          />
          <TextField
            style={{ margin: 5, flex: 1 }}
            id="Contract Date"
            label="customer address"
            variant="standard"
            value={tax_data.customer_address}
            onChange={(e) => {
              set_tax_data({
                ...tax_data,
                customer_address: e.target.value,
              });
            }}
          />
          <TextField
            style={{ margin: 5, flex: 1 }}
            id="Contract Date"
            label="customer phone"
            variant="standard"
            value={tax_data.customer_phone}
            onChange={(e) => {
              set_tax_data({
                ...tax_data,
                customer_phone: e.target.value,
              });
            }}
          />
          <h3>Brief Itinerary</h3>
          {tax_data.brief_itinerary != null
            ? tax_data.brief_itinerary.map((item, index) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <h4>Day {index + 1}</h4>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      checked={item.activities_tax || false}
                      onChange={(e) => {
                        set_tax_data({
                          ...tax_data,
                          brief_itinerary: [
                            ...tax_data.brief_itinerary.slice(0, index),
                            { ...item, activities_tax: e.target.checked },
                            ...tax_data.brief_itinerary.slice(index + 1),
                          ],
                        });
                      }}
                    />
                    <Typography>{item.activities}</Typography>
                  </div>
                  {item.activities_tax == false ? (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <TextField
                        value={item.activities_no_tax_vi}
                        onChange={(e) => {
                          set_tax_data({
                            ...tax_data,
                            brief_itinerary: [
                              ...tax_data.brief_itinerary.slice(0, index),
                              { ...item, activities_no_tax_vi: e.target.value },
                              ...tax_data.brief_itinerary.slice(index + 1),
                            ],
                          });
                        }}
                      />
                      <TextField
                        value={item.activities_no_tax}
                        onChange={(e) => {
                          set_tax_data({
                            ...tax_data,
                            brief_itinerary: [
                              ...tax_data.brief_itinerary.slice(0, index),
                              { ...item, activities_no_tax: e.target.value },
                              ...tax_data.brief_itinerary.slice(index + 1),
                            ],
                          });
                        }}
                      />
                    </div>
                  ) : null}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      checked={item.accomodation_tax || false}
                      onChange={(e) => {
                        set_tax_data({
                          ...tax_data,
                          brief_itinerary: [
                            ...tax_data.brief_itinerary.slice(0, index),
                            { ...item, accomodation_tax: e.target.checked },
                            ...tax_data.brief_itinerary.slice(index + 1),
                          ],
                        });
                      }}
                    />
                    <Typography>{item.accomodation_hotel}</Typography>
                  </div>

                  {item.accomodation_tax == false ? (
                    <TextField
                      value={item.accomodation_no_tax}
                      onChange={(e) => {
                        set_tax_data({
                          ...tax_data,
                          brief_itinerary: [
                            ...tax_data.brief_itinerary.slice(0, index),
                            { ...item, accomodation_no_tax: e.target.value },
                            ...tax_data.brief_itinerary.slice(index + 1),
                          ],
                        });
                      }}
                    />
                  ) : null}
                </div>
              ))
            : null}

          <div style={{ display: "flex", flexDirection: "column" }}>
            <h3>Price</h3>
            <TextField
              style={{ margin: 5, flex: 1 }}
              id="first_deposit"
              variant="outlined"
              value={tax_data.price}
              multiline
              minRows={2}
              onChange={(e) => {
                set_tax_data({
                  ...tax_data,
                  price: e.target.value,
                });
              }}
            />
            <h3>Price Include Vi</h3>
            <TextField
              style={{ margin: 5, flex: 1 }}
              id="price_include_vi"
              variant="outlined"
              value={tax_data.price_include_vi}
              onChange={(e) => {
                set_tax_data({
                  ...tax_data,
                  price_include_vi: e.target.value,
                });
              }}
            />
            <h3>Price Exclude Vi</h3>
            <TextField
              style={{ margin: 5, flex: 1 }}
              id="price_exclude_vi"
              variant="outlined"
              value={tax_data.price_exclude_vi}
              onChange={(e) => {
                set_tax_data({
                  ...tax_data,
                  price_exclude_vi: e.target.value,
                });
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <h3>Detail Itinerary</h3>

            {tax_data.brief_itinerary != null
              ? tax_data.brief_itinerary.map((item, index) => (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <h4>Day {index + 1}</h4>

                    {item.activities_tax == false ? (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <TextField
                          style={{ margin: 5, flex: 1 }}
                          id="detail"
                          multiline
                          minRows={2}
                          variant="outlined"
                          value={item.detail_no_tax_vi}
                          onChange={(e) => {
                            set_tax_data({
                              ...tax_data,
                              brief_itinerary: [
                                ...tax_data.brief_itinerary.slice(0, index),
                                { ...item, detail_no_tax_vi: e.target.value },
                                ...tax_data.brief_itinerary.slice(index + 1),
                              ],
                            });
                          }}
                        />
                        <TextField
                          style={{ margin: 5, flex: 1 }}
                          id="detail"
                          multiline
                          minRows={2}
                          variant="outlined"
                          value={item.detail_no_tax}
                          onChange={(e) => {
                            set_tax_data({
                              ...tax_data,
                              brief_itinerary: [
                                ...tax_data.brief_itinerary.slice(0, index),
                                { ...item, detail_no_tax: e.target.value },
                                ...tax_data.brief_itinerary.slice(index + 1),
                              ],
                            });
                          }}
                        />
                      </div>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <TextField
                          style={{ margin: 5, flex: 1 }}
                          id="detail"
                          multiline
                          minRows={2}
                          variant="outlined"
                          value={item.detail_vi}
                          onChange={(e) => {
                            set_tax_data({
                              ...tax_data,
                              brief_itinerary: [
                                ...tax_data.brief_itinerary.slice(0, index),
                                { ...item, detail_no_tax_vi: e.target.value },
                                ...tax_data.brief_itinerary.slice(index + 1),
                              ],
                            });
                          }}
                        />
                        <TextField
                          style={{ margin: 5, flex: 1 }}
                          id="detail"
                          multiline
                          minRows={2}
                          variant="outlined"
                          value={item.detail}
                          onChange={(e) => {
                            set_tax_data({
                              ...tax_data,
                              brief_itinerary: [
                                ...tax_data.brief_itinerary.slice(0, index),
                                { ...item, detail_no_tax: e.target.value },
                                ...tax_data.brief_itinerary.slice(index + 1),
                              ],
                            });
                          }}
                        />
                      </div>
                    )}
                  </div>
                ))
              : null}
          </div>
        </div>
      ) : (
        <div>No tax data</div>
      )}
    </div>
  );
}
